import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { BaseService } from './base.service';

import { BrokerService } from './broker.service';

@Injectable()
export class ItemService extends BaseService {

  constructor(
    private broker: BrokerService
  ) {
    super();
  }

  getChildren(parentId: number, filter?: any, fields?: Array<string>): Promise<Array<any>> {
    console.log('items:getChildren()');

    if (filter) {
      var newFilter: any = {
        $and: [
          { parentId: parentId }
        ]
      };

      var conditions: Array<any> = newFilter.$and;
      Object.keys(filter).forEach((key: string) => {
        if (filter.hasOwnProperty(key)) {
          var val: any = filter[key];
          conditions.push(val);
        }
      });

      filter = newFilter;
    } else {
      filter = { parentId: parentId };
    }

    var request: any = {
      path: '/api/v1/items',
      queryString: { filter: filter, fields: fields }
    };

    return this.broker.call(request);
  }

  getItems(query?: Object, fields?: Array<string>): Promise<Array<any>> {
    console.log('items:getItems()');

    var request: any = {
      path: '/api/v1/items',
      queryString: { query: query, fields: fields }      
    };

    return this.broker.call(request);
  }

  watchItems(query?: Object, fields?: Array<string>): Promise<Observable<any>> {

    var request: any = {
      path: '/api/v1/items',
      queryString: { query: query, fields: fields }
    };
    return this.broker.subscribe(request);
  }

  getItemById(id: number, fields?: Array<string>): Promise<any> {
    console.log('items:getItemById()');

    var request: any = {
      path: '/api/v1/items/' + id,
      queryString: { fields: fields }
    };

    return this.broker.call(request);
  }

  getVariables(id: number, variables?: Array<string>): Promise<Array<any>> {
    console.log('items:getVariables()');

    var request: any = {
      path: '/api/v1/items/' + id + '/variables',
      queryString: { varNames: variables }
    };

    return this.broker.call(request);
  }

  watchVariables(id: number, variables?: Array<string>): Promise<Observable<any>> {
    console.log('items:watchVariables()');

    var request: any = {
      path: '/api/v1/items/' + id + '/variables',
      queryString: { varNames: variables }
    };

    return this.broker.subscribe(request);
  }

  getProperties(id: number, properties?: Array<string>): Promise<Array<any>> {
    console.log('items:getProperties()');

    var request: any = {
      path: '/api/v1/items/' + id + '/properties',
      queryString: { properties: properties }
    };

    return this.broker.call(request);
  }

  watchProperties(id: number, properties?: Array<string>): Promise<Observable<any>> {
    console.log('items:watchProperties()');

    var request: any = {
      path: '/api/v1/items/' + id + '/properties',
      queryString: { properties: properties }
    };

    return this.broker.subscribe(request);
  }

  updateProperties(id: number, properties: Object): Promise<any> {
    console.log('items:updateProperties()');

    var request: any = {
      method: 'POST',
      path: '/api/v1/items/' + id + '/properties',
      data: properties
    };

    return this.broker.call(request);
  }

  update(id: number, properties: Object): Promise<any> {
    console.log('items:update()');

    var request: any = {
      method: 'PUT',
      path: '/api/v1/items/' + id,
      data: properties
    };

    return this.broker.call(request);
  }

  delete(id: number): Promise<any> {
    var request: any = {
      method: 'DELETE',
      path: '/api/v1/items/' + id
    };

    return this.broker.call(request);
  }

  unwatch(subscriber: any): void {
    console.log('items:getChildren()');
    this.broker.unsubscribe(subscriber);
  }

  getCommands(id: number): Promise<Array<any>> {
    console.log('items:getCommands()');

    var request: any = {
      path: '/api/v1/items/' + id + '/commands'
    };

    return this.broker.call(request);
  }

  executeCommand(id: number, command: any): Promise<any> {
    console.log('items:executeCommand()');

    var request: any = {
      method: 'POST',
      path: '/api/v1/items/' + id + '/commands',
      data: command
    };

    return this.broker.call(request);
  }

  getActions(id: number): Promise<Array<any>> {
    console.log('items:getActions()');

    var request: any = {
      path: '/api/v1/items/' + id + '/actions'
    };

    return this.broker.call(request);
  }

  executeAction(id: number, action: any): Promise<any> {
    console.log('items:executeAction()');

    var request: any = {
      method: 'POST',
      path: '/api/v1/items/' + id + '/actions',
      data: action
    };

    return this.broker.call(request);
  }

  getBindings(id: number, bindingsQuery: any): Promise<Array<any>> {
    console.log('items:getBindings()');

    var request: any = {
      path: '/api/v1/items/' + id + '/bindings',
      queryString: { query: bindingsQuery }      
    };

    return this.broker.call(request);
  }

  getNetwork(id: number): Promise<Array<any>> {
    console.log('items:getNetwork()');

    var request: any = {
      path: '/api/v1/items/' + id + '/network'
    };

    return this.broker.call(request);
  }

  getDocumentation(id: number): Promise<any> {
    console.log('items:getDocumentation()');

    var request: any = {
      path: '/api/v1/items/' + id + '/documentation'
    };

    return this.broker.call(request);
  }

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/item.service.ts